import HexLayout from './src/index.vue'

HexLayout.install = function (Vue) {
  Vue.component(HexLayout.name, HexLayout)
}
export default HexLayout



// WEBPACK FOOTER //
// ./packages/components/layout/index.js